
import { initialState } from './initialState';
import { ROOT_SLICE } from './constants';
import {
  setType,
  setFromAndTo,
  setEnabled,
  setIsInitialized,
  clear
} from './actions';
import { selectThisSlice } from './selectors';

const INITIAL_STATE = initialState;
delete INITIAL_STATE.isInitialized;

// ************
// PARTS
// ************
const reducerParts = {
  [clear]: state => {
    const rootSlice = selectThisSlice(state);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        ...INITIAL_STATE
      }
    };
  },

	[setType]: (
		state,
		{ payload: { type } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				type
			}
		};
  },

	[setEnabled]: (
		state,
		{ payload: { enabled } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				enabled
			}
		};
  },

	[setFromAndTo]: (
		state,
		{ payload: { from, to } }
	) => {
		const rootSlice = selectThisSlice(state);

		return {
			...state,
			[ROOT_SLICE]: {
				...rootSlice,
				from,
				to
			}
		};
  },  

  [setIsInitialized]: (
    state,
    { payload: { isInitialized } }
  ) => {
    const rootSlice = selectThisSlice(state);

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        isInitialized: !!isInitialized,
      }
    };
  },
};


export default reducerParts;
